export default __webpack_public_path__ + "static/media/stella.fa61f674.webp";